import { useQuery } from "react-query";
import { useOrganisationContext, useXeroClient } from "../hooks";

export const useContactGroupsQuery = (config) => {
  const { selectedOrganisation } = useOrganisationContext();
  const id = selectedOrganisation?.id;
  const xero = useXeroClient();

  return useQuery({
    queryKey: ["contactgroups", id],
    queryFn: async () => {
      if (!id) return [];
      return xero.get("contactgroups").get("data");
    },
    ...(config ?? {}),
  });
};
